// Constants
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
// Controls
import { DirectionalHint } from "@fluentui/react";
import { IconIndicator } from "./IconIndicator";
// Models
import { ProgressState } from "@ms/uno-models/lib/local/client/legacyPlanner/progressState/ProgressState";
// Style
import { useTheme } from "@fluentui/react";
import { getContextualMenuStyles } from "../../contextualMenu/ContextualMenu.styles";
import { getProgressIndicatorStyles } from "./Indicators.styles";
// Utilities
import { ConvertPercentCompleteToProgressState, ConvertProgressStateToPercentComplete } from "@ms/uno-models/lib/local/client/legacyPlanner/utilities/ConversionUtilities";
import * as React from "react";
import { useLoggers } from "../../../hooks/useLoggers";
import { getProgressIconProps, IconSize } from "../../../icons/IconUtilities";
/**
 * Progress Indicator component that renders an icon with the current progress of the task
 */ export const ProgressIndicator = (props)=>{
    const { engagementLogger, traceLogger } = useLoggers();
    const { ariaLabel, progressStrings, canUpdateProgress, taskCreationSourceType, onUpdateProgress } = props;
    const theme = useTheme();
    /**
     * Set the progress state for the task
     */ const setProgress = React.useCallback((evt, item)=>{
        engagementLogger.logEngagement("ProgressIndicatorOnTaskCard", EngagementTelemetryConstants.TaskProgressChanged, {
            taskCreationSourceType: taskCreationSourceType ?? ""
        });
        if (Object.values(ProgressState).includes(item.key)) {
            onUpdateProgress(ConvertProgressStateToPercentComplete(ProgressState[item.key]));
        }
    }, [
        engagementLogger,
        taskCreationSourceType,
        onUpdateProgress
    ]);
    const contextMenuItems = React.useMemo(()=>{
        return [
            {
                key: ProgressState.NotStarted,
                name: progressStrings.notStartedText,
                onClick: setProgress,
                iconProps: getProgressIconProps(theme, ProgressState.NotStarted, traceLogger)
            },
            {
                key: ProgressState.InProgress,
                name: progressStrings.inProgressText,
                onClick: setProgress,
                iconProps: getProgressIconProps(theme, ProgressState.InProgress, traceLogger)
            },
            {
                key: ProgressState.Complete,
                name: progressStrings.completedText,
                onClick: setProgress,
                iconProps: getProgressIconProps(theme, ProgressState.Complete, traceLogger)
            }
        ];
    }, [
        progressStrings,
        setProgress,
        theme,
        traceLogger
    ]);
    const progressIconProps = React.useMemo(()=>getProgressIconProps(theme, ConvertPercentCompleteToProgressState(props.percentComplete) ?? ProgressState.InProgress, traceLogger, IconSize.Small), [
        theme,
        traceLogger,
        props.percentComplete
    ]);
    const styles = getProgressIndicatorStyles(theme, ConvertPercentCompleteToProgressState(props.percentComplete) ?? ProgressState.InProgress, canUpdateProgress);
    return /*#__PURE__*/ React.createElement("div", {
        className: "progress indicator",
        title: ariaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: ariaLabel,
        disabled: !canUpdateProgress,
        iconProps: progressIconProps,
        menuProps: {
            calloutProps: {
                className: "plannerAppCallout"
            },
            className: "contextualMenu",
            directionalHint: DirectionalHint.bottomAutoEdge,
            items: contextMenuItems,
            styles: getContextualMenuStyles(theme)
        },
        menuIconProps: {
            iconName: "",
            style: {
                display: "none"
            }
        },
        styles: styles
    }));
};
